import type { LegalDoc } from "../types";
import { LEGAL_COMPANY as C } from "../company";

export const cookie: LegalDoc = {
  slug: "cookie",
  title: "Chính sách Cookie",
  metaTitle: "Chính sách Cookie",
  metaDescription:
    "Cách Chốt Ca sử dụng cookie và công nghệ lưu trữ trên chotca.com và tuyendung.chotca.com.",
  version: "2.0.0",
  effectiveDate: C.effectiveDate,
  intro: `Chính sách này áp dụng cho website ${C.websiteUrl}, trang dành cho nhà tuyển dụng ${C.employerUrl} và các trang con. Ứng dụng di động Chốt Ca **không** dùng cookie HTTP nhưng có sử dụng định danh thiết bị nội bộ — xem mục 5. Chi tiết về dữ liệu cá nhân nói chung tại [Chính sách bảo vệ dữ liệu cá nhân](/privacy).`,
  sections: [
    {
      title: "1. Cookie là gì",
      body: "Cookie là tệp văn bản nhỏ mà website lưu trên trình duyệt của bạn để ghi nhớ trạng thái đăng nhập, tuỳ chọn hiển thị hoặc phục vụ đo lường. Cookie không đọc được các tệp khác trên thiết bị của bạn và không chạy được chương trình.",
    },
    {
      title: "2. Cookie cần thiết",
      body: "Nhóm này giữ cho việc đăng nhập hoạt động và bảo vệ phiên làm việc của bạn. Không có nhóm này thì website không dùng được, nên chúng không cần sự đồng ý riêng và **không thể tắt** trong khi bạn vẫn muốn đăng nhập.",
      items: [
        "**chotca_access** — giữ phiên đăng nhập hiện tại của bạn.",
        "**chotca_refresh**, **chotca_refresh_employer**, **chotca_refresh_admin** — làm mới phiên đăng nhập để bạn không bị đăng xuất liên tục. Mỗi khu vực của hệ thống dùng một cookie riêng.",
        "**chotca_global_role** — ghi nhớ bạn đang đăng nhập ở khu vực nào để hiển thị đúng giao diện.",
        "Cookie kỹ thuật chống giả mạo yêu cầu và cân bằng tải do **Cloudflare** đặt, phục vụ bảo vệ hệ thống khỏi tấn công.",
      ],
    },
    {
      title: "3. Cookie và định danh phục vụ đo lường",
      body: "Chúng tôi dùng các công cụ sau để hiểu website đang hoạt động ra sao và để sửa lỗi. Nhóm này không dùng cho quảng cáo cá nhân hoá:",
      items: [
        "**Google Analytics thông qua Firebase** — đo lưu lượng truy cập, luồng sử dụng và tỉ lệ hoàn thành các bước quan trọng. Với người dùng đã đăng nhập vào khu vực nhà tuyển dụng, chúng tôi gắn mã tài khoản và mã doanh nghiệp vào số liệu để phân tích theo nhóm; chúng tôi **không** gửi họ tên, email hay số điện thoại vào công cụ đo lường.",
        "**Sentry** — ghi nhận sự cố kỹ thuật kèm mã người dùng để chúng tôi tái hiện và sửa lỗi.",
      ],
    },
    {
      title: "4. Cookie quảng cáo",
      body: "Chốt Ca **không** sử dụng cookie quảng cáo, không chạy quảng cáo cá nhân hoá và không chia sẻ dữ liệu cho mạng quảng cáo bên thứ ba. Nếu điều này thay đổi, chúng tôi sẽ bổ sung cơ chế xin đồng ý riêng và cập nhật chính sách này trước khi triển khai.",
    },
    {
      title: "5. Trên ứng dụng di động",
      body: "Ứng dụng di động không dùng cookie HTTP. Thay vào đó, ứng dụng lưu phiên đăng nhập trong vùng lưu trữ an toàn của hệ điều hành và sử dụng:",
      items: [
        "**Mã thông báo đẩy** do Firebase cấp, để gửi thông báo về lời mời phỏng vấn và nhắc lịch. Bạn tắt thông báo bất cứ lúc nào trong cài đặt thiết bị.",
        "**Định danh phiên bản ứng dụng và cấu hình từ xa**, để bật tắt tính năng mà không cần bạn cập nhật ứng dụng.",
        "**Mã sự cố kỹ thuật**, gửi tới Sentry khi ứng dụng gặp lỗi.",
      ],
    },
    {
      title: "6. Quản lý cookie",
      body: "Bạn chặn hoặc xoá cookie bất cứ lúc nào trong trình duyệt: Chrome, Safari, Firefox và Edge đều có mục Cài đặt rồi tới Quyền riêng tư. Lưu ý chặn nhóm cookie cần thiết ở mục 2 sẽ khiến bạn không đăng nhập được. Xoá cookie sẽ đăng xuất bạn khỏi website nhưng không ảnh hưởng tới dữ liệu tài khoản.",
    },
    {
      title: "7. Thay đổi chính sách",
      body: `Chúng tôi cập nhật chính sách khi bổ sung hoặc gỡ bỏ công cụ. Phiên bản mới được đăng tại ${C.websiteUrl}/cookie kèm số phiên bản và ngày hiệu lực.`,
    },
  ],
  contact: {
    title: "8. Liên hệ",
    prefix: "Thắc mắc về cookie và dữ liệu: ",
    email: C.dpoEmail,
  },
};
